import { FC } from "react";
import { ConfirmationDialogStyled } from "@components/Dialogs/ConfirmationDialog/ConfirmationDialogStyled";
import { Alert } from "@components/Dialogs/ConfirmationDialog/content/Alert";

export interface ConfirmationDialogProps {
  open: boolean
  onClose: () => void
  onAgree: () => void
}
const ConfirmationDialog: FC<ConfirmationDialogProps> = ({open, onClose, onAgree}) =>{

  const onCloseHandler = () => {
    onClose()
  }
  const onAgreeHandler = async () => {
   onAgree()
  }
  return (
    <ConfirmationDialogStyled
      disableScrollLock={true}
      open={open}
      onClose={onClose}
    >
    <Alert onCancel={onCloseHandler} onSuccess={onAgreeHandler} isLoading={false}/>
    </ConfirmationDialogStyled>
  )
}
export default ConfirmationDialog